export default [
  {
    header: 'NFTs',
  },
  {
    title: 'Altcoins w/ Pictures',
    route: 'nft',
    icon: 'ImageIcon',
  },
]
